<div class="bouncer" [style.opacity]="opacity"
[class.dark]="dark">
  <div class="bounce1" [style.width]="size + 'px'" [style.height]="size + 'px'"></div>
  <div class="bounce2" [style.width]="size + 'px'" [style.height]="size + 'px'"></div>
  <div class="bounce3" [style.width]="size + 'px'" [style.height]="size + 'px'"></div>
</div>